<template>
  <div class="password_container">
    <div class="top-layout">
      <i class="el-icon-arrow-left" @click="goBack"></i>
      <div v-if="userinfo.loginAccountType === 'phone'">{{ $t('screen.name46') }}</div>
      <div v-else>{{ $t('account.name1') }}</div>
    </div>
      <div class="login" v-if="userinfo.loginAccountType === 'phone'">
        <el-form ref="passWordFormRef1" :model="passWordForm" :rules="passWordFormRules1" label-width="0px" class="login_form">
          <el-form-item prop="phoneNo">
            <el-input v-model="passWordForm.phoneNo" :placeholder="$t('screen.name47')"></el-input>
          </el-form-item>

          <div class="code-layout">
            <el-form-item prop="verCode">
              <el-input v-model="passWordForm.verCode" type="text" :placeholder="$t('retrievePassword.name4')" class="code-input"></el-input>
            </el-form-item>
            <el-button class="code"  size="small" :loading="codeLoading" type="primary" @click="getCode1">{{ sendmsg }}</el-button>
          </div>
        </el-form>
        <el-button class="btns margin-top20" :loading="loading" type="primary" @click="submit(1)">{{ $t('account.name8') }}</el-button>
      </div>
      <div class="login" v-else>
        <el-form ref="passWordFormRef" :model="passWordForm" :rules="passWordFormRules" label-width="0px" class="login_form">
          <el-form-item prop="email">
            <el-input v-model="passWordForm.email" :placeholder="$t('account.name7')"></el-input>
          </el-form-item>

          <div class="code-layout">
            <el-form-item prop="verCode">
              <el-input v-model="passWordForm.verCode" type="text" :placeholder="$t('retrievePassword.name4')" class="code-input"></el-input>
            </el-form-item>
            <el-button class="code"  size="small" :loading="codeLoading" type="primary" @click="getCode">{{ sendmsg }}</el-button>
          </div>
        </el-form>
        <el-button class="btns margin-top20" :loading="loading" type="primary" @click="submit(2)">{{ $t('account.name8') }}</el-button>
      </div>
  </div>
</template>
<script>
import { validateEmail, validatePhone } from '@/utils/utils.js'
import { editEmail, editPhone, editEmailSendEmailCode, editPhoneSendCode } from '@/api/h5.js'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      // 这是登录表单的数据对象
      // passWordForm: {
      //   phoneNo: '',
      //   verCode: ''
      // },
      passWordForm: {
        phoneNo: '',
        email: '',
        verCode: ''
      },
      // 这是表单验证规则对象
      passWordFormRules1: {
        // 验证用户名是否合法

        phoneNo: [
          {
            required: true,
            validator: validatePhone,
            trigger: 'blur'
          }
        ],
        verCode: [
          {
            required: true,
            message: this.$t('login.name4'),
            trigger: 'blur'
          }
        ]
      },
      passWordFormRules: {
        // 验证用户名是否合法
        email: [
          {
            required: true,
            validator: validateEmail,
            trigger: 'blur'
          }
        ],
        verCode: [
          {
            required: true,
            message: this.$t('login.name4'),
            trigger: 'blur'
          }
        ]
      },
      isShowYS: false,
      loading: false,
      checked: false,
      code: '',
      codeLoading: false,
      readonlyInput: true,
      isSend: true,
      sendmsg: this.$t('retrievePassword.name12'),
      language: this.$t('account.name10')
    }
  },
  computed: {
    ...mapGetters(['userinfo'])
  },
  watch: {
    $route: {
      handler: function(route) {
        this.redirect = route.query && route.query.redirect
      }
    }
  },
  mounted() {},
  methods: {
    resetLoginForm() {
      this.$refs.loginFormRef.resetFields()
    },
    showYS() {
      this.isShowYS = !this.isShowYS
    },
    getCode() {
      // if (this.passWordForm.phoneNo && this.passWordForm.phoneNo.length === 11) {
      this.codeLoading = true
      const params = {
        email: this.passWordForm.email
      }
      editEmailSendEmailCode(params)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: this.$t('public.name17'),
              type: 'success'
            })
            this.isSend = false
            let timer = 60
            this.sendmsg = timer + 's'
            this.timeFun = setInterval(() => {
              --timer
              this.sendmsg = timer + 's'
              if (timer === 0) {
                this.isSend = true
                this.sendmsg = this.$t('retrievePassword.name13')
                clearInterval(this.timeFun)
              }
            }, 1000)
          }
          this.codeLoading = false
        })
        .catch(() => {
          this.codeLoading = false
        })
      // }
    },
    getCode1() {
      if (this.passWordForm.phoneNo && this.passWordForm.phoneNo.length === 11) {
        this.codeLoading = true
        const params = {
          phoneNo: 'CN-86-' + this.passWordForm.phoneNo
        }
        editPhoneSendCode(params)
          .then((res) => {
            if (res.code === 200) {
              this.$message({
                message: this.$t('public.name17'),
                type: 'success'
              })
              this.isSend = false
              let timer = 60
              this.sendmsg = timer + 's'
              this.timeFun = setInterval(() => {
                --timer
                this.sendmsg = timer + 's'
                if (timer === 0) {
                  this.isSend = true
                  this.sendmsg = this.$t('retrievePassword.name13')
                  clearInterval(this.timeFun)
                }
              }, 1000)
            }
            this.codeLoading = false
          })
          .catch(() => {
            this.codeLoading = false
          })
      }
    },
    goBack() {
      this.$router.replace({ path: '/home', query: { tab: '3', title: this.$t('account.name12') } })
    },
    submit(type) {
      if (type === 1) {
        this.$refs.passWordFormRef1.validate((valid) => {
          if (valid) {
            this.loading = true
            const params = {
              phoneNo: 'CN-86-' + this.passWordForm.phoneNo,
              verCode: this.passWordForm.verCode
            }
            editPhone(params)
              .then((res) => {
                if (res.code === 200) {
                  this.$message({ message: this.$t('screen.name49'), type: 'success' })
                  this.$store
                    .dispatch('user/getInfo')
                    .then(() => {})
                    .catch(() => {})
                  this.$router.replace({ path: '/home', query: { tab: '3', title: this.$t('account.name12') } })
                }
                this.loading = false
              })
              .catch(() => {
                this.loading = false
              })
          } else {
            return false
          }
        })
      } else {
        this.$refs.passWordFormRef.validate((valid) => {
          if (valid) {
            this.loading = true
            const params = {
              email: this.passWordForm.email,
              verCode: this.passWordForm.verCode
            }
            editEmail(params)
              .then((res) => {
                if (res.code === 200) {
                  this.$message({ message: this.$t('screen.name48'), type: 'success' })
                  this.$store
                    .dispatch('user/getInfo')
                    .then(() => {})
                    .catch(() => {})
                  this.$router.replace({ path: '/home', query: { tab: '3', title: this.$t('account.name12') } })
                }
                this.loading = false
              })
              .catch(() => {
                this.loading = false
              })
          } else {
            return false
          }
        })
      }
    }
  }
}
</script>
<style lang="scss">
.login{
  .el-input__inner{
    height: 49px;
  line-height: 49px;
  border: 0px solid #DCDFE6;
  background: #F6F7FB;
  }
}
</style>

<style lang="scss" scoped>
.password_container {
  background: #fff;
  // background-size: cover;
  width: 100%;
  height: 100vh;
  // overflow: hidden;
  // background-image: url(~@/assets/login/Maskgroup.jpg);
  // background-size: 100% 100%;
  .img {
    width: 100%;
    height: 24.65vw;
    // min-width: 1440px;
    min-height: 355px;
    position: absolute;
    bottom: 0;
    left: 0;
  }
.code-layout {
  display: flex;
  overflow: hidden;
  // align-items: center;
  // height: 37px;
  justify-content: space-between;
  width: 100%;
}
.text-style {
  font-family: PingFang SC;
  font-size: 15px;
  font-weight: 400;
  line-height: 22.4px;
  cursor: pointer;
}

.btns {
  width: 100%;
  text-align: center;
  margin-top: 20px;
  font-size: 16px;
}
.margin-top20 {
  margin-top: 20px;
}

.checked-forget {
  margin-top: -10px;
  width: 100%;
  display: flex;
  align-items: center;
}
.zsb-tyb {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 34px;
}
.ystk {
  color: #0f73e6;
}

.icon-zsb {
  display: flex;
  align-items: center;
  cursor: pointer;
  img {
    width: 16px;
    height: 16px;
  }
  span {
    margin-left: 4px;
    font-size: 16px;
    line-height: 22.4px;
  }
}
.el-icon-refresh {
  margin-bottom: 22px;
  margin-left: 8px;
}
.code-input {
  // width:calc(100vw - 160px);
}
.code {
  height: 49px;
  font-size: 14px;
  margin-top: 1px;
  text-align: center;
  margin-left: 10px;
  // width: 120px;
  color: #fff;
  cursor: pointer;
}

.fhzsb {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 20px;
  margin-left: 20px;
  cursor: pointer;
  img {
    width: 16px;
    height: 16px;
  }
  .text {
    font-family: PingFang SC;
    font-size: 14px;
    font-weight: 400;
    line-height: 19.6px;
    color: #b9babb;
    margin-left: 4px;
  }
}
.text1{
  font-size: 20px;
  margin-left: 15px;
  font-weight: 600;
  color: #555555;
  margin-top: 30px;
}
.text2{
  font-size: 12px;
  color: #555555;
  margin-left: 15px;
  margin-top: 10px;
}

.top-layout {
  width: 100%;
  display: flex;
  align-items: center;
  position: relative;
  height: 54px;
  .el-icon-arrow-left {
   font-size: 18px;
   font-weight: 600;
   margin-left: 15px;
   cursor: pointer;
  }
  div {
    position: absolute;
    left: 50%;
    transform: translate(-50%, 0);
    font-size: 16px;
    font-weight: 800;
    line-height: 28px;
    text-align: left;
    color: #171717;
  }
}

.login {
  width: 100%;
  padding-top: 0px;
  padding: 30px 15px 15px 15px;
  border-radius: 0px;
  box-sizing: border-box;
  position: relative;
}

.login_logo {
  width: 120px;
  height: 120px;
  border: 5px solid #93defe;
  border-radius: 100px;
  background: #fff;
  text-align: center;
  line-height: 110px;
  position: absolute;
  top: -60px;
  right: 140px;
}

.login_name {
  width: 100%;
  text-align: center;
}

.login_name div {
  width: 100%;
  text-align: center;
  font-size: 24px;
  margin-bottom: 40px;
  line-height: 33.6px;
  font-weight: 500;
  color: #555555;
  font-family: PingFang SC;
}

.login_logo img {
  width: 100px;
  height: 70px;
  display: inline-block;
  vertical-align: middle;
}
}
</style>
